import { Box, Flex } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';

interface SelectionBarProps {
  /** Currently selected count. */
  selected: number;
  /** Total selectable rows. */
  total: number;
  /** Plural noun for the zero-selection state ("candidates", "jobs"). */
  noun: string;
  onSelectAll: () => void;
  onClear: () => void;
  testId?: string;
}

// Compact selection summary above checkbox-based result lists. Before this,
// the only trace of a selection was a "(N)" suffix inside chip labels — no
// select-all, no clear, no persistent count. One line fixes all three.
export const SelectionBar = ({
  selected,
  total,
  noun,
  onSelectAll,
  onClear,
  testId,
}: SelectionBarProps) => {
  if (total <= 1) return null;
  const allSelected = selected === total;
  return (
    <Flex align="center" gap="10px" data-test-id={testId}>
      <Text variant="small" as="span" className="text-secondary-600">
        {selected > 0 ? `${selected} of ${total} selected` : `${total} ${noun}`}
      </Text>
      <Box
        as="button"
        type="button"
        onClick={allSelected ? onClear : onSelectAll}
        className="text-[12px] font-medium text-primary-700 hover:underline cursor-pointer"
        data-test-id={testId ? `${testId}-toggle-all` : undefined}
      >
        {allSelected ? 'Clear selection' : 'Select all'}
      </Box>
      {selected > 0 && !allSelected && (
        <Box
          as="button"
          type="button"
          onClick={onClear}
          className="text-[12px] text-secondary-500 hover:underline cursor-pointer"
          data-test-id={testId ? `${testId}-clear` : undefined}
        >
          Clear
        </Box>
      )}
    </Flex>
  );
};
